import * as yup from "yup";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	taa010Descricao: yup.string().required(translate("Descrição do tipo é requerido")),
	taa010Ativo: yup.boolean()
});

export default  addAndChangeSchema;
